<template>
	<div>
		<div style="display: flex; justify-content: space-between; align-items: center;">
			<v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>
			<p style="display: inline;" class="add-event-example-sub-header-light mb-0">Example {{exampleIndex+1}}/{{examples.length}}</p>
			<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn>
		</div>
		<v-divider class="mb-3"></v-divider>
		<p class="add-event-example-sub-header">{{ examples[exampleIndex].title }}</p>
		<p class="add-event-example-content"><span class="bolded">Description</span> - {{ examples[exampleIndex].description }}</p>
		<p class="add-event-example-content"><span class="bolded">Rules</span> - {{ examples[exampleIndex].rules }}</p>
	</div>
</template>

<script>
export default {
	data() {
		return {
			exampleIndex: 0,
			examples: [
				{
					title: "Sophie's Sanctuary",
					description:
						"Sophia's is a secluded modern cottage hidden within a luscious garden. Beautiful artwork, vaulted ceilings, and serence views in every direction. Plenty of seating options to choose from (both inside and outside). Perfect for focus and flow and just steps away for Abbot Kinney (great spot for lunch!).",
					rules: 'Please, no shoes inside the house'
				},
				{
					title: 'Dev House',
					description:
						"At Dev House you'll find a productive work environment with plenty of workstation options, a foosball table, and an outdoor patio.  All are welcome here, and for those who need we have a few extra monitors.",
					rules:
						"No upstairs access.  Any smoking must be done in the backyard.  If you'd like to cook in the kitchen there are utensils for you to use. Just make sure to clean up after yourself."
				},
				{
					title: 'The Bungalow',
					description:
						'A stone throw from the beach!  The space includes a rooftop deck (with hammock!), a balcony overlooking the Venice Canal, and a cozy interior design with a huge community table and many other individual spots to work.  Note: an adorable cat lives here!',
					rules:
						'Shoe free house!  Please be extra friendly if you meet neighbors while entering or exiting the building.  Thanks!'
				}
			]
		}
	},
	methods: {
		lastExample() {
			this.exampleIndex -= 1
			if (this.exampleIndex < 0) {
				this.exampleIndex = this.examples.length - 1
			}
		},
		nextExample() {
			this.exampleIndex += 1
			if (this.exampleIndex >= this.examples.length) {
				this.exampleIndex = 0
			}
		}
	}
}
</script>
